module.exports = __webpack_public_path__ + "img/point2_bgcircle05.aa48dfb5.png";